import { assertType } from "graphql";
import * as React from "react";

export default class PostCardPicture extends React.Component {
  constructor(props) {
    super(props);

    this.picture = {
      medium: this.props.node.featured_media_medium_url,
      large: this.props.node.featured_media_large_url,
      width: this.props.node.featured_media_size ? this.props.node.featured_media_size[0] : " ",
      height: this.props.node.featured_media_size ? this.props.node.featured_media_size[1] : " ",
    };
  }

  render() {
    return (
      <picture className="d-block mb-3 overflow-hidden rounded-4" style={{ aspectRatio: "1440/634" }}>
        {this.props.large && <source srcSet={this.picture.large + ` 768w`} />}
        {this.picture.medium && (
          <img
            src={this.picture.medium}
            alt={this.props.node.title}
            width={this.picture.width}
            height={this.picture.height}
            className="mw-100 rounded-4"
            loading="lazy"
            style={{ height: "auto" }}
          />
        )}
      </picture>
    );
  }
}
